import { HttpEndpoint } from '@/api/httpEndpoints';
import { delay } from '@shared/utils/async';
import {
    PreCheckoutData,
    SaveSelectionRequest,
    SaveSelectionResponse,
} from '@shared/interfaces/preCheckout';
import {
    CheckoutEndpoint as CheckoutEndpointModel,
    DiscountCodeResponse,
    StaticCheckoutContent,
} from '@/api/Checkout/checkout.interfaces';
import { fakeStaticCheckoutContent, fakePreCheckout } from '@/api/Checkout/checkout.fake';
import { Market } from '@shared/config/market/market.models';
import { getCurrentMarketSpecs } from '@shared/config/market/market.helpers';
const market: Market = getCurrentMarketSpecs();
const Currency = market.moneyFormat.currency;

export class CheckoutEndpoint extends HttpEndpoint implements CheckoutEndpointModel {
    public constructor(applicationUrl: string) {
        super(applicationUrl);
    }

    public async GetStaticCheckoutPageContent(): Promise<StaticCheckoutContent> {
        return await this.get<StaticCheckoutContent>(
            'mvc/Checkout/GetStaticCheckoutPageContent'
        );
    }

    public async GetPreCheckoutData(optionLimit?: number): Promise<PreCheckoutData> {
        const limit = Number(optionLimit);

        return await this.get<PreCheckoutData>(
            this.buildPathWithQuery('mvc/PreCheckout/GetPreCheckoutPageContent', {
                ...(!isNaN(limit) && limit > 0 && { optionLimit: limit.toString() }),
            })
        );
    }

    public async SavePreCheckoutSelections(
        data: SaveSelectionRequest
    ): Promise<SaveSelectionResponse> {
        return this.post('/mvc/PreCheckout/SaveSelections', {
            selections: JSON.stringify(data),
        });
    }

    public async RedeemDiscountCode(discountCode: string): Promise<DiscountCodeResponse> {
        return await this.post('mvc/CampaignCode/GetDiscountCodeAmount', {
            discountCode,
        });
    }
}

export class FakeCheckoutEndpoint extends HttpEndpoint implements CheckoutEndpointModel {
    public async GetStaticCheckoutPageContent(): Promise<StaticCheckoutContent> {
        await delay(600);
        return fakeStaticCheckoutContent;
    }

    public async GetPreCheckoutData(): Promise<PreCheckoutData> {
        await delay(1000);
        return fakePreCheckout;
    }

    public async SavePreCheckoutSelections(): Promise<SaveSelectionResponse> {
        const fail = true;

        await delay(2000);

        return {
            IsValid: !fail,
            Errors: fail
                ? [
                      {
                          Message: 'You need to add cabins for 4 passengers',
                          AddonId: 'aaasda2-872s8-f23as-joficz877',
                          OptionId: null,
                      },
                      {
                          Message: 'You may not select more than 4 of this cabin',
                          AddonId: 'aaasda2-872s8-f23as-joficz877',
                          OptionId: '17322',
                      },
                  ]
                : [],
        };
    }

    public async RedeemDiscountCode(discountCode: string): Promise<DiscountCodeResponse> {
        const validDiscountCodes = [
            {
                Code: 'sembo',
                Value: {
                    Amount: 166,
                    Currency,
                },
            },
            {
                Code: 'holidays',
                Value: {
                    Amount: 420,
                    Currency,
                },
            },
            {
                Code: 'h4ck3r',
                Value: {
                    Amount: 314,
                    Currency,
                },
            },
            {
                Code: 'hotsauce',
                Value: {
                    Amount: 699,
                    Currency,
                },
            },
        ];

        const validCode = validDiscountCodes.find((c) => c.Code === discountCode);
        await delay(1000);
        if (validCode === undefined) {
            return {
                Discount: null,
                ErrorMessage: 'The discount code is not valid!',
            };
        }
        return {
            Discount: validCode.Value,
            ErrorMessage: '',
        };
    }
}
